import React, { useEffect } from 'react';
import { Award, Globe2, Building2, HeartHandshake } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { companyInfo, stats } from '../mock';
import { StatsBar } from '../components/StatsAndDevelopers';
import { InstagramCta } from '../components/BlogFaqInstagram';

const About = () => {
  const { t } = useApp();
  useEffect(() => { window.scrollTo(0, 0); document.title = 'About | GOBRA Capital Real Estate'; }, []);
  const values = [
    { icon: Award, title: 'Excellence', desc: 'A relentless pursuit of excellence in every transaction and every relationship.' },
    { icon: Globe2, title: 'Global Reach', desc: 'Advisors fluent in 10+ languages serving clients from every corner of the world.' },
    { icon: Building2, title: 'Trusted Partners', desc: 'Direct access to the UAE\u2019s most prominent developers and their finest launches.' },
    { icon: HeartHandshake, title: 'Client First', desc: 'One trusted partner for every real estate decision, from first viewing to handover.' },
  ];
  return (
    <main className="pt-24 md:pt-28">
      <section className="relative h-[46vh] min-h-[360px] overflow-hidden">
        <img src="https://images.unsplash.com/photo-1512453979798-5ea266f8880c?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000" alt="Dubai" className="h-full w-full object-cover" />
        <div className="absolute inset-0 gobra-hero-overlay" />
        <div className="absolute inset-0 flex flex-col justify-center max-w-[1400px] mx-auto px-4 md:px-8">
          <span className="text-gobra-orange text-sm font-semibold tracking-[0.25em] mb-3">{t('hero_kicker')}</span>
          <h1 className="font-title text-4xl md:text-6xl font-bold text-white max-w-2xl">Every real estate decision. One trusted partner.</h1>
        </div>
      </section>

      <section className="max-w-[900px] mx-auto px-4 md:px-8 py-16 md:py-20 text-center">
        <div className="h-1 w-12 bg-gobra-terracotta rounded-full mb-4 mx-auto" />
        <h2 className="font-title text-3xl md:text-4xl font-bold text-gobra-slate">{companyInfo.name}</h2>
        <p className="text-muted-foreground text-lg mt-5 leading-relaxed">
          GOBRA Capital Real Estate is a Dubai-based brokerage built on trust, craftsmanship and a deep understanding of the UAE property market. We curate the finest off-plan launches, ready homes and investment opportunities from Dubai's most prominent developers &ndash; guiding a global clientele in their own language and currency.
        </p>
      </section>

      <StatsBar />

      <section className="max-w-[1400px] mx-auto px-4 md:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((v) => (
            <div key={v.title} className="bg-white border border-gobra-sand rounded-xl p-6">
              <span className="h-12 w-12 rounded-xl bg-gobra-green/10 flex items-center justify-center">
                <v.icon className="h-6 w-6 text-gobra-green" />
              </span>
              <h3 className="font-title text-xl font-semibold text-gobra-slate mt-4">{v.title}</h3>
              <p className="text-muted-foreground text-sm mt-2 leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <InstagramCta />
    </main>
  );
};

export default About;
